<template>
  <template v-for="(social, index) in $cfg.socialItems" :key="index">
    <div class="mr-2.5 flex items-center" :class="props.footer ? 'mb-2.5' : ''">
      <!-- Innovadis custom: XSS fix - sanitize href URL to prevent javascript: URL injection (AIKIDO) -->
      <a
        class="flex items-center justify-center rounded-full bg-[color:var(--color-newsletter-input-bg)] text-[color:var(--color-header-top-link)] hover:text-[color:var(--color-primary-500)]"
        target="_blank"
        :href="getSafeUrl(social.link)"
        :class="props.small ? 'w-6 h-6' : 'w-10 h-10'"
      >
        <VcIcon v-if="social.type" :name="social.type" :size="16" />
      </a>
      <!-- eslint-enable -->
    </div>
  </template>
</template>

<script setup lang="ts">
import { getSafeUrl } from "@/core/utilities";

const props = defineProps({
  small: {
    type: Boolean,
    default: false,
  },

  footer: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.icon-small {
  width: 15px;
  height: 15px;
}

.icon-large {
  width: 20px;
  height: 20px;
}
</style>
